var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockchainDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 211.87 195.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:url(#linear-gradient-6);}.cls-2,.cls-3,.cls-4,.cls-5{fill-opacity:.44;}.cls-6{fill:url(#radial-gradient-5);}.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11{fill-opacity:.75;}.cls-12{fill:rgba(255,255,255,.2);}.cls-13,.cls-14{fill:rgba(125,162,254,.5);}.cls-15{fill:rgba(125,162,254,.75);}.cls-3{fill:url(#linear-gradient-8);}.cls-7{fill:url(#radial-gradient-3);}.cls-16{stroke:url(#linear-gradient-10);}.cls-16,.cls-14,.cls-17{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-16,.cls-17{fill:none;}.cls-4{fill:url(#linear-gradient-7);}.cls-5{fill:url(#linear-gradient-5);}.cls-14{stroke:#fff;}.cls-8{fill:url(#radial-gradient);}.cls-9{fill:url(#radial-gradient-2);}.cls-18{fill:url(#linear-gradient-3);}.cls-19{fill:url(#linear-gradient);}.cls-17{stroke:url(#linear-gradient-9);}.cls-10{fill:url(#radial-gradient-4);}.cls-20{fill:url(#linear-gradient-4);}.cls-11{fill:url(#radial-gradient-6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 65.95,
    y1: 125.04,
    x2: 65.95,
    y2: 23.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -448.2,
    y1: 125.04,
    x2: -448.2,
    y2: 23.38,
    gradientTransform: "translate(-425.55) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 22.65,
    y1: 150.04,
    x2: 22.65,
    y2: 48.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -491.5,
    y1: 150.04,
    x2: -491.5,
    y2: 48.38,
    gradientTransform: "translate(-425.55) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.54,
    y1: 128.71,
    x2: 44.78,
    y2: 148.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 42.37,
    y1: 77.75,
    x2: 45.99,
    y2: 121.07,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 65.86,
    cy: 138.03,
    fx: 65.86,
    fy: 138.03,
    r: 47.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5aa6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1b86f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#386aff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 210.87,
    y1: 138.32,
    x2: 171.42,
    y2: 138.32,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 165.64,
    y1: 77.75,
    x2: 169.26,
    y2: 121.07,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -410.85,
    cy: 138.03,
    fx: -410.85,
    fy: 138.03,
    r: 47.91,
    gradientTransform: "translate(-264.85) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 100.2,
    cy: 154.89,
    fx: 100.2,
    fy: 154.89,
    r: 4.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52a2f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -380.59,
    y1: 150.17,
    x2: -343.2,
    y2: 150.17,
    gradientTransform: "translate(-234.31) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8cc0f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 65.59,
    y1: 147.88,
    x2: 110.89,
    y2: 147.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8cc0f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1b86f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1b86f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8cc0f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#6db0f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#4fa1f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3895f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#278cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#1e87f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 145.28,
    cy: 139.95,
    fx: 145.28,
    fy: 139.95,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 74.32,
    cy: 139.95,
    fx: 74.32,
    fy: 139.95,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 74.32,
    cy: 139.95,
    fx: 74.32,
    fy: 139.95,
    r: 9.26,
    xlinkHref: "#radial-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "87.6 150.82 44.3 125.82 44.3 0 87.6 25 87.6 150.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1 150.82 44.3 125.82 44.3 0 1 25 1 150.82"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "44.3 175.82 1 150.82 1 25 44.3 50 44.3 175.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "44.3 175.82 87.6 150.82 87.6 25 44.3 50 44.3 175.82"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "210.87 169.35 167.56 194.35 124.26 169.35 167.56 144.35 210.87 169.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "87.6 169.35 44.3 194.35 1 169.35 44.3 144.35 87.6 169.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "87.6 150.82 44.3 175.82 1 150.82 44.3 125.82 87.6 150.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "44.3 125.82 1 150.82 1 100.82 44.3 75.82 44.3 125.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "87.6 150.82 44.3 125.82 44.3 75.82 87.6 100.82 87.6 150.82"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "74.32 143.15 44.3 160.49 14.28 143.15 44.3 125.82 74.32 143.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "44.3 125.82 14.28 143.15 14.28 108.49 44.3 91.16 44.3 125.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "44.3 160.49 14.28 143.15 14.28 108.49 44.3 125.82 44.3 160.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "74.32 143.15 44.3 125.82 44.3 91.16 74.32 108.49 74.32 143.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "74.32 108.49 44.3 125.82 14.28 108.49 44.3 91.16 74.32 108.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "74.32 143.15 44.3 160.49 44.3 125.82 74.32 108.49 74.32 143.15"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "44.3 175.82 1 150.82 1 100.82 44.3 125.82 44.3 175.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.6 100.82 44.3 125.82 1 100.82 44.3 75.82 87.6 100.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "87.6 150.82 44.3 175.82 44.3 125.82 87.6 100.82 87.6 150.82"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "210.87 150.82 167.56 175.82 124.26 150.82 167.56 125.82 210.87 150.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "167.56 125.82 124.26 150.82 124.26 100.82 167.56 75.82 167.56 125.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "210.87 150.82 167.56 125.82 167.56 75.82 210.87 100.82 210.87 150.82"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "197.59 143.15 167.56 160.49 137.54 143.15 167.56 125.82 197.59 143.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "167.56 125.82 137.54 143.15 137.54 108.49 167.56 91.16 167.56 125.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "167.56 160.49 137.54 143.15 137.54 108.49 167.56 125.82 167.56 160.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "197.59 143.15 167.56 125.82 167.56 91.16 197.59 108.49 197.59 143.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "197.59 108.49 167.56 125.82 137.54 108.49 167.56 91.16 197.59 108.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "197.59 143.15 167.56 160.49 167.56 125.82 197.59 108.49 197.59 143.15"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "210.87 150.82 167.56 175.82 167.56 125.82 210.87 100.82 210.87 150.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "210.87 100.82 167.56 125.82 124.26 100.82 167.56 75.82 210.87 100.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "124.26 150.82 167.56 175.82 167.56 125.82 124.26 100.82 124.26 150.82"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 100.2,
    cy: 154.89,
    r: 4.73
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 109.89,
    y1: 160.38,
    x2: 145.28,
    y2: 139.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 109.89,
    y1: 160.38,
    x2: 66.59,
    y2: 135.38
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 145.28,
    cy: 139.95,
    r: 4.73
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 74.32,
    cy: 139.95,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 74.32,
    cy: 139.95,
    r: 9.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "210.87 74.48 167.56 99.48 124.26 74.48 167.56 49.48 210.87 74.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "201.37 52.86 167.56 72.38 133.76 52.86 167.56 33.35 201.37 52.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "192.32 29.97 167.56 44.26 142.81 29.97 167.56 15.67 192.32 29.97"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainDevelopment);
export default __webpack_public_path__ + "static/media/blockchain-development.fdd982aa47552eb00fab3a516446f0ed.svg";
export { ForwardRef as ReactComponent };